import { getAndValidateLoansAndCreditsInfoTypeData } from '@sec-loans-ui/wizard/steps/applicant-info-phase/loans-and-credits-info-step/loansAndCreditsInfoStepUtils'
import { WizardData } from '@sec-loans-ui/wizard/types'
import { getAppData } from '@sec-loans-ui/wizard/wizardData'
import { SecLoansApplicationMetadata } from '@shared/sec-loans'
import { OpenModalEvent } from '@ui-common/components/Modal'
import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { ReactNode } from 'react'
import { IntlShape } from 'react-intl'

import { ValidationParams } from '../wizard/wizardMachine'

export const getHasDependantChanges = ({
  wizardData,
  changedData,
  applicationMetadata,
  validationParams,
}: {
  wizardData: WizardData
  changedData: WizardData
  applicationMetadata: SecLoansApplicationMetadata
  validationParams: ValidationParams
}): boolean => {
  const updatedData = getAppData(changedData, applicationMetadata, validationParams)
  return [
    wizardData.targetInfo?.isComplete && !updatedData.targetInfo?.isComplete,
    wizardData.applicantInfo?.isComplete && !updatedData.applicantInfo?.isComplete,
    wizardData.loanInfo?.isComplete && !updatedData.loanInfo?.isComplete,
  ].some(Boolean)
}

export const showDependantChangesModal = (
  onSubmit: (data: WizardData) => void,
  modalSend: (openModalEvent: OpenModalEvent) => void,
  children: ReactNode,
  intl: IntlShape,
  data: WizardData,
): void => {
  const openEvent: OpenModalEvent = {
    type: 'OPEN',
    data: {
      header: intl.formatMessage({ id: 'sec-loans-dependant-changes-modal-header' }),
      children,
      primaryButtonOptions: {
        label: intl.formatMessage({ id: 'common-cancel' }),
        type: 'primary',
      },
      secondaryButtonOptions: {
        label: intl.formatMessage({ id: 'common-continue-anyway' }),
        onClick: () => onSubmit(data),
      },
      mode: ModalVisualMode.Help,
    },
  }
  modalSend(openEvent)
}

export const onFormSubmitCheckDependantData = ({
  wizardData,
  changedData,
  applicationMetadata,
  validationParams,
  submit,
  modalSend,
  children,
  intl,
}: {
  wizardData: WizardData
  changedData: WizardData
  applicationMetadata: SecLoansApplicationMetadata
  validationParams: ValidationParams
  submit: (data: WizardData) => void
  modalSend: (openModalEvent: OpenModalEvent) => void
  children: ReactNode
  intl: IntlShape
}): void => {
  let dependenciesAppliedData: WizardData = changedData
  if (dependenciesAppliedData.applicantInfo?.loansAndCreditsInfoData) {
    const { data: loansAndCreditsInfoData, isComplete } =
      getAndValidateLoansAndCreditsInfoTypeData({ validationData: dependenciesAppliedData, applicationMetadata }) ?? {}

    dependenciesAppliedData = {
      ...dependenciesAppliedData,
      applicantInfo: {
        ...dependenciesAppliedData.applicantInfo,
        loansAndCreditsInfoData,
        isComplete: !!(dependenciesAppliedData.applicantInfo.isComplete && isComplete),
      },
    }
  }
  const dependantChanges = getHasDependantChanges({
    wizardData,
    changedData: dependenciesAppliedData,
    applicationMetadata,
    validationParams,
  })
  if (dependantChanges) {
    showDependantChangesModal(submit, modalSend, children, intl, dependenciesAppliedData)
  } else {
    submit(dependenciesAppliedData)
  }
}
